import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { AddProfileDialogComponent } from "../add-profile-dialog/add-profile-dialog.component";
import { DataCatalogueService } from "../../services/data-catalogue.service";
import { ACL } from "../../model/acl";
import { ProfileData } from "../feature-access-rights/feature-access-rights.component";

@Component({
  selector: "app-data-type-access-rights",
  templateUrl: "./data-type-access-rights.component.html",
  styleUrl: "./data-type-access-rights.component.scss",
})
export class DataTypeAccessRightsComponent implements OnInit {
  customValue: string = "";
  // accessRights = [
  //   {
  //     enabled: true,
  //     profileName: "Default with OTHER code",
  //   },
  //   {
  //     enabled: false,
  //     profileName: "MET",
  //   },
  // ];

  accessDisplayedColumns: string[] = ["enable", "profileName"];
  aclData: any;
  profilesMap: Record<string, string> = {};
  dataSource: ProfileData[] = [];

  constructor(
    private dialog: MatDialog,
    private catalogueService: DataCatalogueService,
    public dialogRef: MatDialogRef<DataTypeAccessRightsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { value: string; dataType: string }
  ) {}
  ngOnInit() {
    this.loadProfiles(() => {
      this.loadACL();
    });
  }
  private loadProfiles(done: () => void): void {
    this.catalogueService
      .getProfiles("2037172d-1390-4033-9017-e5424166927e")
      .subscribe({
        next: (profiles) => {
          this.profilesMap = {};

          profiles.forEach((p: any) => {
            this.profilesMap[p.uuid] = p.name;
          });

          done();
        },
        error: (err) => {
          console.error("Error loading profiles:", err);
          done();
        },
      });
  }
  private loadACL(): void {
    this.catalogueService
      .getEnumACL(
        "2037172d-1390-4033-9017-e5424166927e",
        "aixm",
        this.data.dataType,
        this.data.value
      )

      .subscribe({
        next: (res) => {
          this.aclData = res;

          this.dataSource = res.map((item: any) => ({
            profile: this.profilesMap[item.ref] ?? item.ref,
            read: item.read,
            create: item.create,
            update: item.update,
            decommission: item.decommission,
            mandatory: item.mandatory ?? false,
            ref: item.ref,
          }));
          // this.dataSource.push({
          //   profile: "Other profiles",
          //   read: false,
          //   create: false,
          //   update: false,
          //   decommission: false,
          //   mandatory: false,
          // });
        },
        error: (err) => {
          console.error("Error loading ACL:", err);
        },
      });
  }

 
  onClose(): void {
    this.dialogRef.close();
  }

  onSave(): void {
      const aclUpdate: ACL = this.dataSource
      .filter((item) => item.ref)
      .map((item) => ({
        ref: item.ref,
        read: item.read,
        create: item.create,
        update: item.update,
        decommission: item.decommission,
        mandatory: item.mandatory,
      }));

    this.catalogueService
      .updateEnumACL("2037172d-1390-4033-9017-e5424166927e",
        "aixm",
        this.data.dataType,
        this.data.value, aclUpdate)
      .subscribe({
        next: (res) => console.log("ACL updated:", res),
        error: (err) => console.error("Error updating ACL:", err),
      });

    this.dialogRef.close(aclUpdate);
  }


  // openAddProfileDialog(): void {
  //   const dialogRef = this.dialog.open(AddProfileDialogComponent, {
  //     width: "400px",
  //     data: {},
  //   });

  //   dialogRef.afterClosed().subscribe((selectedProfiles: any[]) => {
  //     if (selectedProfiles && selectedProfiles.length) {
  //       selectedProfiles.forEach((profile) => {
  //         const exists = this.accessRights.some(
  //           (p) => p.profileName === profile.name
  //         );
  //         if (!exists) {
  //           this.accessRights.push({
  //             enabled: false,
  //             profileName: profile.name,
  //           });
  //         }
  //       });

  //       this.accessRights.sort((a, b) =>
  //         a.profileName.localeCompare(b.profileName)
  //       );

  //       this.accessRights = [...this.accessRights];
  //     }
  //   });
  // }

    openAddProfileDialog(): void {
    const dialogRef = this.dialog.open(AddProfileDialogComponent, {
      width: "400px",
      data: {},
    });

    dialogRef.afterClosed().subscribe((selectedProfiles: any[]) => {
      if (selectedProfiles && selectedProfiles.length) {
        selectedProfiles.forEach((profile) => {
          const exists = this.dataSource.some(
            (p) => p.profile === profile.name
          );
          if (!exists) {
            this.dataSource.push({
              profile: profile.name,
              ref: profile.ref,
              read: false,
              create: false,
              update: false,
              decommission: false,
              mandatory: false,
            });
          }
        });

        this.dataSource.sort((a, b) => {
          if (a.profile === "Other profiles") return 1;
          if (b.profile === "Other profiles") return -1;
          return a.profile.localeCompare(b.profile);
        });

        this.dataSource = [...this.dataSource];
        console.log(this.dataSource, "ovo je datasource");
      }
    });
  }
}
